import { CurrencyAndCategories } from "../../../domain/projections/Category";
import { CategoryRepository } from "../../../domain/repositories/CategoryRepository";
import { createHttpClients } from "../shared/createHttpClients";
import { CategoriesDTO, mapCategoriesDTOtoCurrencyAndCategories } from "./responseMapper";

class CategoryRepositoryImpl implements CategoryRepository {
  private static instance: CategoryRepositoryImpl;

  private constructor() {}

  public static getInstance(): CategoryRepositoryImpl {
    if (!CategoryRepositoryImpl.instance) {
      CategoryRepositoryImpl.instance = new CategoryRepositoryImpl();
    }

    return CategoryRepositoryImpl.instance;
  }

  public async getCurrencyAndCategories(
    apiUrl: () => string,
    auth: string,
    moreProductsPerCategory: boolean,
  ): Promise<CurrencyAndCategories> {
    try {
      const { httpPost } = createHttpClients(auth, apiUrl);
      const response = await httpPost<CategoriesDTO>({
        endpoint: `/categories/v2/view-recommendation`,
        body: { moreProductsPerCategory: moreProductsPerCategory ? 1 : 0 },
      });
      return mapCategoriesDTOtoCurrencyAndCategories(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export { CategoryRepositoryImpl };
